import LocalStorage from './LocalStorage'

export default LocalStorage
